<template>
  <div class=" tw-px-4 ">
    <!-- 标题区域 - 在背景图上方 -->
    <div class="tw-w-full tw-text-center tw-mb-2" style="margin-top: 40px;">
      <span class="tw-text-textMain tw-text-xl md:tw-text-4xl tw-font-bold tw-mb-4 tw-block">
        {{ $t("全球化区块链生态布局") }}
      </span>
      <span class="tw-w-full tw-text-center tw-text-xs md:tw-text-sm tw-text-textDisabled tw-block">
        {{ $t("从技术研发到生态落地，已为全球多个国家和地区提供成熟Web3开发服务") }}
      </span>
    </div>
    <div class="we-can-do-wrapper">
      <div class="tw-flex tw-flex-col tw-items-center">
        <div 
          class="tab-view-container data-card"
          :class="{ 'animate-slide-up': isVisible }"
        >
          <div class="data-grid">
            <div 
              v-for="(item, index) in dataList" 
              :key="index"
              class="data-item"
            >
              <img 
                :src="item.icon" 
                alt=""
                class="data-icon"
              />
              <div class="data-content">
                <div class="data-number" :style="{ color: item.color }">
                  {{ animatedValues[index] }}
                  <span class="data-unit">{{ $t(item.unit) }}</span>
                </div>
                <div class="data-label">{{ $t(item.label) }}</div>
              </div>
            </div>
          </div>
        </div>
        <img src="~@/assets/home/mobileWorld.png" alt="" class="world-image">
      </div>
    </div>
  </div>
</template>

<script>
import world01 from "@/assets/home/world01.png";
import world02 from "@/assets/home/world02.png";
import world03 from "@/assets/home/world03.png";
import world04 from "@/assets/home/world04.png";

export default {
  name: 'WeCanDo',
  data() {
    return {
      tabsList: [],
      isLoading: true,
      isVisible: false,
      observer: null,
      animationStarted: false,
      dataList: [
        {
          icon: world01,
          targetValue: 6,
          unit: "家",
          label: "海内外公司",
          color: "#EEA809"
        },
        {
          icon: world02,
          targetValue: 16,
          unit: "年+",
          label: "开发经验",
          color: "#9657FC"
        },
        {
          icon: world03,
          targetValue: 200,
          unit: "+",
          label: "技术团队",
          color: "#4077F8"
        },
        {
          icon: world04,
          targetValue: 10,
          unit: "W+",
          label: "企业客户",
          color: "#64C885"
        }
      ],
      animatedValues: [0, 0, 0, 0]
    };
  },
  mounted() {
    const info = JSON.parse(localStorage.getItem('indexInfo'));
    if (info) {
      this.getList();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    initIntersectionObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isVisible) {
            this.isVisible = true;
            this.startNumberAnimation();
            this.observer.disconnect();
          }
        });
      }, {
        threshold: 0.1,
      });

      this.observer.observe(this.$el);
    },

    startNumberAnimation() {
      if (this.animationStarted) return;
      this.animationStarted = true;

      this.dataList.forEach((item, index) => {
        setTimeout(() => {
          this.animateNumber(
            0,
            item.targetValue,
            1500,
            (value) => {
              this.$set(this.animatedValues, index, Math.floor(value));
            }
          );
        }, index * 200);
      });
    },

    animateNumber(start, end, duration, callback) {
      const startTime = performance.now();
      const change = end - start;

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 4);
        const currentValue = start + change * easeProgress;

        callback(currentValue);

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    },

    getList() {
      // 静态数据，无需API
    }
  }
};
</script>

<style scoped lang="scss">
.we-can-do-wrapper {
  width: 100%;
  padding: 20px 0px;
  
  @media (min-width: 768px) {
    padding: 20px 0px;
  }
}

.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}

.data-card {
  width: 100%;
  max-width: 335px;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px 0px rgba(183,189,255,0.25);
  border-radius: 12px;
  padding: 30px;
  aspect-ratio: 335 / 168;
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 20px;
  height: 100%;
}

.data-item {
  display: flex;
  align-items: center;
}

.data-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.data-content {
  margin-left: 12px;
  flex: 1;
}

.data-number {
  font-weight: 600;
  font-size: 18px;
  line-height: 1;
  margin-bottom: 4px;
}

.data-unit {
  font-weight: 600;
  font-size: 18px;
}

.data-label {
  font-weight: 600;
  font-size: 12px;
  color: #666666;
}

.world-image {
  width: 100%;
  height: auto;
  margin-top: 20px;
}
</style>
